module.exports = __webpack_public_path__ + "static/media/icon_urgente_small.71595538.svg";